import { apiCall } from "./service";
import { BASE_URL } from "./URL";

// Owner entity route segment per Timeline entityType - "projectTimeline" (Project's own Timeline
// tab) still owns/creates events under the Projects controller, same as "project" would.
const ENTITY_ROUTE = {
  portfolio: "Portfolios",
  program: "Programs",
  project: "Projects",
  projectTimeline: "Projects",
};

const keyEventsService = {
  createKeyEvent: async (entityType, entityId, payload) => {
    try {
      const params = {
        url: `${BASE_URL}${ENTITY_ROUTE[entityType]}/${entityId}/TimeLine-key-event`,
        params: payload
      };
      const response = await apiCall.post(params);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updateKeyEvent: async (entityType, entityId, eventId, payload) => {
    try {
      const params = {
        url: `${BASE_URL}${ENTITY_ROUTE[entityType]}/${entityId}/TimeLine-key-event/${eventId}`,
        params: payload
      };

      const response = await apiCall.put(params);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  deleteKeyEvent: async (entityType, entityId, eventId) => {
    try {
      const payload = {
        url: `${BASE_URL}${ENTITY_ROUTE[entityType]}/${entityId}/TimeLine-key-event/${eventId}`
      };
      const response = await apiCall.delete(payload);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default keyEventsService;
